import { useEffect, useState, useContext } from 'react';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import CircularProgress from '@mui/material/CircularProgress';
// material
import { Card, CardHeader, Box, Typography, Alert } from '@mui/material';
// context
import { ReportContext } from '../../../contexts/Report';
// halpers
import { roundNumber, getTimeZoneGTM } from '../../../helpers/Util';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------

export default function AppDailySalesChart() {
  const [chartLabels, setChartLabels] = useState([]);
  const [chartData, setChartData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const {
    salesPerDay,
    isLoading: isLoadingSalesPerDay,
    hasError: hasErrorSalesPerDay
  } = useContext(ReportContext);

  useEffect(() => {
    const setData = async () => {
      try {
        const chartLabels = salesPerDay.perDay.map((sale) => sale._id);
        const chartData = [
          {
            name: 'Sales',
            data: salesPerDay.perDay.map((sale) => roundNumber(sale.totalAmount))
          }
        ];

        setChartLabels(chartLabels);
        setChartData(chartData);
      } catch (err) {
        setHasError(true);
        console.error(err);
      }

      setIsLoading(false);
    };

    if (!isLoadingSalesPerDay && !hasErrorSalesPerDay) {
      setData();
    }
  }, [salesPerDay, isLoadingSalesPerDay, hasErrorSalesPerDay]);

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      type: 'line',
      height: 350,
      stacked: true
    },
    stroke: {
      curve: 'straight'
    },
    labels: [...chartLabels],
    xaxis: { type: 'datetime' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y} €`;
          }
          return y;
        }
      }
    }
  });

  if (hasError || hasErrorSalesPerDay) {
    return (
      <Alert severity="error">
        An error occurred while trying to load the daily sales — Please, try to refresh the page!
      </Alert>
    );
  }

  return (
    <Card>
      <CardHeader
        title="Daily Sales"
        subheader={`Last 30 days (GTM${getTimeZoneGTM({ date: new Date() })})`}
      />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        {isLoading || isLoadingSalesPerDay ? (
          <Typography align="center" variant="h3">
            <CircularProgress size={30} color="inherit" />
          </Typography>
        ) : (
          <ReactApexChart type="line" series={chartData} options={chartOptions} height={364} />
        )}
      </Box>
    </Card>
  );
}
